import { defineStore } from 'pinia';

// key是将path：/index/index改为 index_index
type CountInfo = {
  /** 首页 */
  index_index: number;

  cn: number;
  na: number;
  eu: number;
  ap: number;
};

const DefaultCount = {
  index_index: 0,
  cn: 0,
  na: 0,
  eu: 0,
  ap: 0,
};

export const useCountStore = defineStore('count', {
  state: () => {
    const countInfo: CountInfo = {
      ...DefaultCount,
    };
    return {
      countInfo,
    };
  },
  actions: {
    getCount() {
      const countKeys = Object.keys(DefaultCount);
      return Promise.resolve({ position: countKeys }).then((res) => {
        countKeys.forEach((key) => {
          const val = res?.[key] || res?.count?.[key] || 0;
          this.countInfo[key] = val;
        });
      });
    },
  },
  persist: false,
});
